import { render, staticRenderFns } from "./app-select-city-with-region.vue?vue&type=template&id=5c40b393"
import script from "./app-select-city-with-region.vue?vue&type=script&lang=js"
export * from "./app-select-city-with-region.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports